<template>
  <div class="support-card mb-5">
    <div
      class="bg-secondary rounded-[5px] px-[20px] md:px-[30px] py-[30px] md:py-[40px] relative max-md:mb-2 max-md:h-[290px]"
    >
      <h2 class="text-mobile-heading-3 md:text-heading-3 mb-4 z-20 relative">
        {{ t("index.getSupport") }}
      </h2>

      <div class="flex">
        <LazyTitleBorder
          v-if="hasTitleBorder"
          width="thin"
          bgColor1="bg-white"
        />
        <div
          class="text-mobile-paragraph-1 md:text-paragraph-1 text-gray-1"
          :class="{ 'ltr:pl-[10px] rtl:pr-[10px]': hasTitleBorder }"
        >
          {{ t("index.supportDescription") }}
        </div>
      </div>
      <div
        class="flex absolute bottom-[30px] md:bottom-[40px] ltr:left-[30px] rtl:right-[30px] text-mobile-link-1 md:text-link-1 text-primary-1 items-center uppercase cursor-pointer"
        @click="router.push(localePath({ name: 'about' }))"
      >
        {{ t("menu.aboutUs") }}
        <icon-bordered-arrow class="text-[40px] !mb-0" />
      </div>
    </div>
    <div
      class="bg-primary-2 rounded-[5px] px-[20px] md:px-[30px] py-[40px] text-white relative"
    >
      <div class="shadow-box-1 max-md:hidden z-10"></div>

      <div
        class="md:absolute md:bottom-0 top-0 flex flex-col justify-center gap-[22px] md:gap-[30px]"
      >
        <a class="info" v-if="info?.address?.address_description">
          <div class="icon-bg">
            <icon-location class="" />
          </div>
          <span class="flex-1">
            {{ info?.address?.address_description }}
          </span>
        </a>
        <a v-if="info?.email" class="info" :href="`mailto:${info?.email}`">
          <div class="icon-bg">
            <icon-email class="" />
          </div>
          {{ info?.email }}
        </a>
        <a
          v-if="info?.telephones?.length"
          class="info"
          :tel="info?.telephones[0]"
          :href="`tel:${info?.telephones[0]}`"
        >
          <div class="icon-bg">
            <icon-call class="" />
          </div>
          <span dir="ltr">{{ info?.telephones[0] }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import type { ICompanyInfo } from "../../../types/general";
import { useAsyncData } from "nuxt/app";
const { t } = useI18n();
const router = useRouter();
const localePath = useLocalePath();
defineProps({
  hasTitleBorder: { type: Boolean, default: true },
});
const locale = useCookie("locale").value;
const { data: info } = await useAsyncData<ICompanyInfo | null>(
  `about-${locale}`,
  () => customFetch(`api/company-info?lang=${locale}`)
);
</script>
<style scoped>
.support-card {
  @apply md:grid grid-cols-2 gap-5 overflow-hidden md:h-[304px];
  .info {
    @apply flex items-center block text-mobile-heading-6 md:text-heading-6;
    svg {
      @apply text-[22px] text-primary-2;
    }
  }
}

.shadow-box-1 {
  position: absolute;
  top: 5%;
  left: 3%;
  width: 90px;
  height: 90px;
  border-radius: 100%;
  background: var(--primary-2-darker);
  filter: blur(30px) drop-shadow(0 0 10px var(--primary-2));
  opacity: 0.25;
}
.icon-bg {
  @apply bg-secondary p-[9px] rounded-[5px] ltr:mr-[20px] rtl:ml-[20px] w-[44px] h-[44px] flex justify-center items-center;
}
</style>
